import * as React from 'react';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import { TABLE_HEADER_BACKGROUND_COLOR } from '../../../constants/colors';
import { OrderStatusEnum } from '../../../enums/orderStatus';
import { useTranslation } from 'react-i18next';

interface Props {
  value: OrderStatusEnum,
  onChange: (newValue: OrderStatusEnum) => void,
}

export default function ProductTabPanel({ value, onChange }: Props) {
  const { t } = useTranslation("global");
  return (
    <Box sx={{ width: '100%', backgroundColor: TABLE_HEADER_BACKGROUND_COLOR }}>
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs value={value} onChange={(e: any, newValue: OrderStatusEnum) => {
          onChange(newValue)
        }} aria-label="basic tabs example" variant="scrollable"
          scrollButtons="auto">
          <Tab label={t("order_page.Current order")} value={OrderStatusEnum.CURRENT_ORDER} sx={{ textTransform: 'none' }} />
          <Tab label={t("order_page.To pack")} value={OrderStatusEnum.To_Pack} sx={{ textTransform: 'none' }} />
          <Tab label={t("order_page.To ship")} value={OrderStatusEnum.To_Ship} sx={{ textTransform: 'none' }} />
          <Tab label={t("order_page.Rider getting product")} value={OrderStatusEnum.Rider_Getting_Order} sx={{ textTransform: 'none' }} />
          <Tab label={t("order_page.Shipping")} value={OrderStatusEnum.Shipping} sx={{ textTransform: 'none' }} />
          <Tab label={t("order_page.Pick up")} value={OrderStatusEnum.READY_TO_PICKUP} sx={{ textTransform: 'none' }} />
          {/* <Tab label={OrderStatusEnum.Delivered} value={OrderStatusEnum.Delivered} sx={{ textTransform: 'none' }} /> */}
          {/*  <Tab label={OrderStatusEnum.Return} value={OrderStatusEnum.Return} sx={{ textTransform: 'none' }} />
          <Tab label={OrderStatusEnum.Failed} value={OrderStatusEnum.Failed} sx={{ textTransform: 'none' }} /> */}
        </Tabs>
      </Box>
    </Box>
  );
}
